import React from 'react'

import Sparkline from './Sparkline'

/**
 * Stat tile: label, value, optional change line, caption and sparkline.
 *
 * `change` is `describeChange`'s `{ direction, amount, window }`
 * (activityReport.js), shown to the right of the value: the arrow and
 * percentage on top, the comparison window ("vs prev 4 weeks") under it.
 * Null for none. Wraps under the value when the tile is too narrow.
 *
 * The value uses proportional figures deliberately -- tabular-nums gives every
 * digit the width of a zero, which makes a number like 121 look loose at display
 * size. Tabular figures belong in table columns, not here.
 */
const CHANGE_ICONS = { up: 'fa-arrow-up', down: 'fa-arrow-down', flat: 'fa-minus' }

const StatTile = ({ label, value, caption, change, spark, tone, accent, testId }) => (
    <div className={`viz-stat-tile${accent ? ` viz-stat-tile--${accent}` : ''}`}>
        <div className="viz-stat-label">{label}</div>
        <div className="viz-stat-value-row">
            <div className="viz-stat-value" data-testid={testId}>
                {typeof value === 'number' ? value.toLocaleString() : value}
            </div>
            {change && (
                <div
                    className={`viz-stat-change viz-stat-change--${change.direction}`}
                    data-testid={testId ? `${testId}-change` : undefined}
                >
                    <div className="viz-stat-change-amount">
                        <i className={`fa ${CHANGE_ICONS[change.direction]}`} aria-hidden="true"></i> {change.amount}
                    </div>
                    <div className="viz-stat-change-window">{change.window}</div>
                </div>
            )}
        </div>
        {caption && <div className="viz-stat-caption">{caption}</div>}
        {spark && spark.length > 1 && (
            <div className="viz-stat-spark">
                <Sparkline values={spark} tone={tone} />
            </div>
        )}
    </div>
)

export const StatTileRow = ({ children }) => <div className="viz-stat-row">{children}</div>

export default StatTile
